export default {
  countries: [
    { name: 'United States', code: 'US', countryCallingCode: '+1' },
    { name: 'Afghanistan', code: 'AF', countryCallingCode: '+93' },
    { name: 'Åland Islands', code: 'AX', countryCallingCode: '+358' },
    { name: 'Albania', code: 'AL', countryCallingCode: '+355' },
    { name: 'Algeria', code: 'DZ', countryCallingCode: '+213' },
    { name: 'American Samoa', code: 'AS', countryCallingCode: '+1-684' },
    { name: 'Andorra', code: 'AD', countryCallingCode: '+376' },
    { name: 'Angola', code: 'AO', countryCallingCode: '+244' },
    { name: 'Anguilla', code: 'AI', countryCallingCode: '+1-264' },
    { name: 'Antarctica', code: 'AQ', countryCallingCode: '+672' },
    { name: 'Antigua and Barbuda', code: 'AG', countryCallingCode: '+1-268' },
    { name: 'Argentina', code: 'AR', countryCallingCode: '+54' },
    { name: 'Armenia', code: 'AM', countryCallingCode: '+374' },
    { name: 'Aruba', code: 'AW', countryCallingCode: '+297' },
    { name: 'Australia', code: 'AU', countryCallingCode: '+61' },
    { name: 'Austria', code: 'AT', countryCallingCode: '+43' },
    { name: 'Azerbaijan', code: 'AZ', countryCallingCode: '+994' },
    { name: 'Bahamas', code: 'BS', countryCallingCode: '+1-242' },
    { name: 'Bahrain', code: 'BH', countryCallingCode: '+973' },
    { name: 'Bangladesh', code: 'BD', countryCallingCode: '+880' },
    { name: 'Barbados', code: 'BB', countryCallingCode: '+1-246' },
    { name: 'Belarus', code: 'BY', countryCallingCode: '+375' },
    { name: 'Belgium', code: 'BE', countryCallingCode: '+32' },
    { name: 'Belize', code: 'BZ', countryCallingCode: '+501' },
    { name: 'Benin', code: 'BJ', countryCallingCode: '+229' },
    { name: 'Bermuda', code: 'BM', countryCallingCode: '+1-441' },
    { name: 'Bhutan', code: 'BT', countryCallingCode: '+975' },
    { name: 'Bolivia', code: 'BO', countryCallingCode: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', countryCallingCode: '+387' },
    { name: 'Botswana', code: 'BW', countryCallingCode: '+267' },
    { name: 'Bouvet Island', code: 'BV', countryCallingCode: '+47' },
    { name: 'Brazil', code: 'BR', countryCallingCode: '+55' },
    {
      name: 'British Indian Ocean Territory',
      code: 'IO',
      countryCallingCode: '+246'
    },
    { name: 'Brunei Darussalam', code: 'BN', countryCallingCode: '+673' },
    { name: 'Bulgaria', code: 'BG', countryCallingCode: '+359' },
    { name: 'Burkina Faso', code: 'BF', countryCallingCode: '+226' },
    { name: 'Burundi', code: 'BI', countryCallingCode: '+257' },
    { name: 'Cambodia', code: 'KH', countryCallingCode: '+855' },
    { name: 'Cameroon', code: 'CM', countryCallingCode: '+237' },
    { name: 'Canada', code: 'CA', countryCallingCode: '+1' },
    { name: 'Cape Verde', code: 'CV', countryCallingCode: '+238' },
    { name: 'Cayman Islands', code: 'KY', countryCallingCode: '+1-345' },
    {
      name: 'Central African Republic',
      code: 'CF',
      countryCallingCode: '+236'
    },
    { name: 'Chad', code: 'TD', countryCallingCode: '+235' },
    { name: 'Chile', code: 'CL', countryCallingCode: '+56' },
    { name: 'China', code: 'CN', countryCallingCode: '+86' },
    { name: 'Christmas Island', code: 'CX', countryCallingCode: '+61' },
    { name: 'Cocos (Keeling) Islands', code: 'CC', countryCallingCode: '+61' },
    { name: 'Colombia', code: 'CO', countryCallingCode: '+57' },
    { name: 'Comoros', code: 'KM', countryCallingCode: '+269' },
    { name: 'Congo', code: 'CG', countryCallingCode: '+242' },
    {
      name: 'Congo, The Democratic Republic of the',
      code: 'CD',
      countryCallingCode: '+243'
    },
    { name: 'Cook Islands', code: 'CK', countryCallingCode: '+682' },
    { name: 'Costa Rica', code: 'CR', countryCallingCode: '+506' },
    { name: "Cote D'Ivoire", code: 'CI', countryCallingCode: '+225' },
    { name: 'Croatia', code: 'HR', countryCallingCode: '+385' },
    { name: 'Cuba', code: 'CU', countryCallingCode: '+53' },
    { name: 'Cyprus', code: 'CY', countryCallingCode: '+357' },
    { name: 'Czech Republic', code: 'CZ', countryCallingCode: '+420' },
    { name: 'Denmark', code: 'DK', countryCallingCode: '+45' },
    { name: 'Djibouti', code: 'DJ', countryCallingCode: '+253' },
    { name: 'Dominica', code: 'DM', countryCallingCode: '+1-767' },
    { name: 'Dominican Republic', code: 'DO', countryCallingCode: '+1-809' },
    { name: 'Ecuador', code: 'EC', countryCallingCode: '+593' },
    { name: 'Egypt', code: 'EG', countryCallingCode: '+20' },
    { name: 'El Salvador', code: 'SV', countryCallingCode: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', countryCallingCode: '+240' },
    { name: 'Eritrea', code: 'ER', countryCallingCode: '+291' },
    { name: 'Estonia', code: 'EE', countryCallingCode: '+372' },
    { name: 'Ethiopia', code: 'ET', countryCallingCode: '+251' },
    {
      name: 'Falkland Islands (Malvinas)',
      code: 'FK',
      countryCallingCode: '+500'
    },
    { name: 'Faroe Islands', code: 'FO', countryCallingCode: '+298' },
    { name: 'Fiji', code: 'FJ', countryCallingCode: '+679' },
    { name: 'Finland', code: 'FI', countryCallingCode: '+358' },
    { name: 'France', code: 'FR', countryCallingCode: '+33' },
    { name: 'French Guiana', code: 'GF', countryCallingCode: '+594' },
    { name: 'French Polynesia', code: 'PF', countryCallingCode: '+689' },
    {
      name: 'French Southern Territories',
      code: 'TF',
      countryCallingCode: '+262'
    },
    { name: 'Gabon', code: 'GA', countryCallingCode: '+241' },
    { name: 'Gambia', code: 'GM', countryCallingCode: '+220' },
    { name: 'Georgia', code: 'GE', countryCallingCode: '+995' },
    { name: 'Germany', code: 'DE', countryCallingCode: '+49' },
    { name: 'Ghana', code: 'GH', countryCallingCode: '+233' },
    { name: 'Gibraltar', code: 'GI', countryCallingCode: '+350' },
    { name: 'Greek', code: 'GR', countryCallingCode: '+30' },
    { name: 'Greenland', code: 'GL', countryCallingCode: '+299' },
    { name: 'Grenada', code: 'GD', countryCallingCode: '+1-473' },
    { name: 'Guadeloupe', code: 'GP', countryCallingCode: '+590' },
    { name: 'Guam', code: 'GU', countryCallingCode: '+1-671' },
    { name: 'Guatemala', code: 'GT', countryCallingCode: '+502' },
    { name: 'Guernsey', code: 'GG', countryCallingCode: '+44-1481' },
    { name: 'Guinea', code: 'GN', countryCallingCode: '+224' },
    { name: 'Guinea-Bissau', code: 'GW', countryCallingCode: '+245' },
    { name: 'Guyana', code: 'GY', countryCallingCode: '+592' },
    { name: 'Haiti', code: 'HT', countryCallingCode: '+509' },
    {
      name: 'Heard Island and Mcdonald Islands',
      code: 'HM',
      countryCallingCode: '+672'
    },
    {
      name: 'Holy See (Vatican City State)',
      code: 'VA',
      countryCallingCode: '+39-06'
    },
    { name: 'Honduras', code: 'HN', countryCallingCode: '+504' },
    { name: 'Hong Kong', code: 'HK', countryCallingCode: '+852' },
    { name: 'Hungary', code: 'HU', countryCallingCode: '+36' },
    { name: 'Iceland', code: 'IS', countryCallingCode: '+354' },
    { name: 'India', code: 'IN', countryCallingCode: '+91' },
    { name: 'Indonesia', code: 'ID', countryCallingCode: '+62' },
    {
      name: 'Iran, Islamic Republic Of',
      code: 'IR',
      countryCallingCode: '+98'
    },
    { name: 'Iraq', code: 'IQ', countryCallingCode: '+964' },
    { name: 'Ireland', code: 'IE', countryCallingCode: '+353' },
    { name: 'Isle of Man', code: 'IM', countryCallingCode: '+44-1624' },
    { name: 'Israel', code: 'IL', countryCallingCode: '+972' },
    { name: 'Italy', code: 'IT', countryCallingCode: '+39' },
    { name: 'Jamaica', code: 'JM', countryCallingCode: '+1-876' },
    { name: 'Japan', code: 'JP', countryCallingCode: '+81' },
    { name: 'Jersey', code: 'JE', countryCallingCode: '+44-1534' },
    { name: 'Jordan', code: 'JO', countryCallingCode: '+962' },
    { name: 'Kazakhstan', code: 'KZ', countryCallingCode: '+7' },
    { name: 'Kenya', code: 'KE', countryCallingCode: '+254' },
    { name: 'Kiribati', code: 'KI', countryCallingCode: '+686' },
    {
      name: "Korea, Democratic People'S Republic of",
      code: 'KP',
      countryCallingCode: '+850'
    },
    { name: 'Korea, Republic of', code: 'KR', countryCallingCode: '+82' },
    { name: 'Kuwait', code: 'KW', countryCallingCode: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', countryCallingCode: '+996' },
    {
      name: "Lao People'S Democratic Republic",
      code: 'LA',
      countryCallingCode: '+856'
    },
    { name: 'Latvia', code: 'LV', countryCallingCode: '+371' },
    { name: 'Lebanon', code: 'LB', countryCallingCode: '+961' },
    { name: 'Lesotho', code: 'LS', countryCallingCode: '+266' },
    { name: 'Liberia', code: 'LR', countryCallingCode: '+231' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY', countryCallingCode: '+218' },
    { name: 'Liechtenstein', code: 'LI', countryCallingCode: '+423' },
    { name: 'Lithuania', code: 'LT', countryCallingCode: '+370' },
    { name: 'Luxembourg', code: 'LU', countryCallingCode: '+352' },
    { name: 'Macao', code: 'MO', countryCallingCode: '+853' },
    {
      name: 'Macedonia, The Former Yugoslav Republic of',
      code: 'MK',
      countryCallingCode: '+389'
    },
    { name: 'Madagascar', code: 'MG', countryCallingCode: '+261' },
    { name: 'Malawi', code: 'MW', countryCallingCode: '+265' },
    { name: 'Malaysia', code: 'MY', countryCallingCode: '+60' },
    { name: 'Maldives', code: 'MV', countryCallingCode: '+960' },
    { name: 'Mali', code: 'ML', countryCallingCode: '+223' },
    { name: 'Malta', code: 'MT', countryCallingCode: '+356' },
    { name: 'Marshall Islands', code: 'MH', countryCallingCode: '+692' },
    { name: 'Martinique', code: 'MQ', countryCallingCode: '+596' },
    { name: 'Mauritania', code: 'MR', countryCallingCode: '+222' },
    { name: 'Mauritius', code: 'MU', countryCallingCode: '+230' },
    { name: 'Mayotte', code: 'YT', countryCallingCode: '+262' },
    { name: 'Mexico', code: 'MX', countryCallingCode: '+52' },
    {
      name: 'Micronesia, Federated States of',
      code: 'FM',
      countryCallingCode: '+691'
    },
    { name: 'Moldova, Republic of', code: 'MD', countryCallingCode: '+373' },
    { name: 'Monaco', code: 'MC', countryCallingCode: '+377' },
    { name: 'Mongolia', code: 'MN', countryCallingCode: '+976' },
    { name: 'Montserrat', code: 'MS', countryCallingCode: '+1-664' },
    { name: 'Morocco', code: 'MA', countryCallingCode: '+212' },
    { name: 'Mozambique', code: 'MZ', countryCallingCode: '+258' },
    { name: 'Myanmar', code: 'MM', countryCallingCode: '+95' },
    { name: 'Namibia', code: 'NA', countryCallingCode: '+264' },
    { name: 'Nauru', code: 'NR', countryCallingCode: '+674' },
    { name: 'Nepal', code: 'NP', countryCallingCode: '+977' },
    { name: 'Netherlands', code: 'NL', countryCallingCode: '+31' },
    { name: 'Netherlands Antilles', code: 'AN', countryCallingCode: '+599' },
    { name: 'New Caledonia', code: 'NC', countryCallingCode: '+687' },
    { name: 'New Zealand', code: 'NZ', countryCallingCode: '+64' },
    { name: 'Nicaragua', code: 'NI', countryCallingCode: '+505' },
    { name: 'Niger', code: 'NE', countryCallingCode: '+227' },
    { name: 'Nigeria', code: 'NG', countryCallingCode: '+234' },
    { name: 'Niue', code: 'NU', countryCallingCode: '+683' },
    { name: 'Norfolk Island', code: 'NF', countryCallingCode: '+672' },
    {
      name: 'Northern Mariana Islands',
      code: 'MP',
      countryCallingCode: '+1-670'
    },
    { name: 'Norway', code: 'NO', countryCallingCode: '+47' },
    { name: 'Oman', code: 'OM', countryCallingCode: '+968' },
    { name: 'Pakistan', code: 'PK', countryCallingCode: '+92' },
    { name: 'Palau', code: 'PW', countryCallingCode: '+680' },
    {
      name: 'Palestinian Territory, Occupied',
      code: 'PS',
      countryCallingCode: '+970'
    },
    { name: 'Panama', code: 'PA', countryCallingCode: '+507' },
    { name: 'Papua New Guinea', code: 'PG', countryCallingCode: '+677' },
    { name: 'Paraguay', code: 'PY', countryCallingCode: '+595' },
    { name: 'Peru', code: 'PE', countryCallingCode: '+51' },
    { name: 'Philippines', code: 'PH', countryCallingCode: '+63' },
    { name: 'Pitcairn', code: 'PN', countryCallingCode: '+64' },
    { name: 'Poland', code: 'PL', countryCallingCode: '+48' },
    { name: 'Portugal', code: 'PT', countryCallingCode: '+351' },
    { name: 'Puerto Rico', code: 'PR', countryCallingCode: '+1-787' },
    { name: 'Qatar', code: 'QA', countryCallingCode: '+974' },
    { name: 'Reunion', code: 'RE', countryCallingCode: '+262' },
    { name: 'Romania', code: 'RO', countryCallingCode: '+40' },
    { name: 'Russian Federation', code: 'RU', countryCallingCode: '+7' },
    { name: 'Rwanda', code: 'RW', countryCallingCode: '+250' },
    { name: 'Saint Helena', code: 'SH', countryCallingCode: '+290' },
    { name: 'Saint Kitts and Nevis', code: 'KN', countryCallingCode: '+1-869' },
    { name: 'Saint Lucia', code: 'LC', countryCallingCode: '+1-758' },
    {
      name: 'Saint Pierre and Miquelon',
      code: 'PM',
      countryCallingCode: '+508'
    },
    {
      name: 'Saint Vincent and the Grenadines',
      code: 'VC',
      countryCallingCode: '+1-784'
    },
    { name: 'Samoa', code: 'WS', countryCallingCode: '+685' },
    { name: 'San Marino', code: 'SM', countryCallingCode: '+378' },
    { name: 'Sao Tome and Principe', code: 'ST', countryCallingCode: '+239' },
    { name: 'Saudi Arabia', code: 'SA', countryCallingCode: '+966' },
    { name: 'Senegal', code: 'SN', countryCallingCode: '+221' },
    { name: 'Serbia and Montenegro', code: 'CS', countryCallingCode: '+381' },
    { name: 'Seychelles', code: 'SC', countryCallingCode: '+248' },
    { name: 'Sierra Leone', code: 'SL', countryCallingCode: '+232' },
    { name: 'Singapore', code: 'SG', countryCallingCode: '+65' },
    { name: 'Slovakia', code: 'SK', countryCallingCode: '+421' },
    { name: 'Slovenia', code: 'SI', countryCallingCode: '+386' },
    { name: 'Solomon Islands', code: 'SB', countryCallingCode: '+677' },
    { name: 'Somalia', code: 'SO', countryCallingCode: '+252' },
    { name: 'South Africa', code: 'ZA', countryCallingCode: '+27' },
    {
      name: 'South Georgia and the South Sandwich Islands',
      code: 'GS',
      countryCallingCode: '+500'
    },
    { name: 'Spain', code: 'ES', countryCallingCode: '+34' },
    { name: 'Sri Lanka', code: 'LK', countryCallingCode: '+94' },
    { name: 'Sudan', code: 'SD', countryCallingCode: '+249' },
    { name: 'Suriname', code: 'SR', countryCallingCode: '+597' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ', countryCallingCode: '+47' },
    { name: 'Swaziland', code: 'SZ', countryCallingCode: '+268' },
    { name: 'Sweden', code: 'SE', countryCallingCode: '+46' },
    { name: 'Switzerland', code: 'CH', countryCallingCode: '+41' },
    { name: 'Syrian Arab Republic', code: 'SY', countryCallingCode: '+963' },
    {
      name: 'Taiwan, Province of China',
      code: 'TW',
      countryCallingCode: '+886'
    },
    { name: 'Tajikistan', code: 'TJ', countryCallingCode: '+992' },
    {
      name: 'Tanzania, United Republic of',
      code: 'TZ',
      countryCallingCode: '+255'
    },
    { name: 'Thailand', code: 'TH', countryCallingCode: '+66' },
    { name: 'Timor-Leste', code: 'TL', countryCallingCode: '+670' },
    { name: 'Togo', code: 'TG', countryCallingCode: '+228' },
    { name: 'Tokelau', code: 'TK', countryCallingCode: '+690' },
    { name: 'Tonga', code: 'TO', countryCallingCode: '+676' },
    { name: 'Trinidad and Tobago', code: 'TT', countryCallingCode: '+1-868' },
    { name: 'Tunisia', code: 'TN', countryCallingCode: '+216' },
    { name: 'Turkey', code: 'TR', countryCallingCode: '+90' },
    { name: 'Turkmenistan', code: 'TM', countryCallingCode: '+993' },
    {
      name: 'Turks and Caicos Islands',
      code: 'TC',
      countryCallingCode: '+1-649'
    },
    { name: 'Tuvalu', code: 'TV', countryCallingCode: '+688' },
    { name: 'Uganda', code: 'UG', countryCallingCode: '+256' },
    { name: 'Ukraine', code: 'UA', countryCallingCode: '+380' },
    { name: 'United Arab Emirates', code: 'AE', countryCallingCode: '+971' },
    { name: 'United Kingdom', code: 'GB', countryCallingCode: '+44' },
    {
      name: 'United States Minor Outlying Islands',
      code: 'UM',
      countryCallingCode: '+1'
    },
    { name: 'Uruguay', code: 'UY', countryCallingCode: '+598' },
    { name: 'Uzbekistan', code: 'UZ', countryCallingCode: '+998' },
    { name: 'Vanuatu', code: 'VU', countryCallingCode: '+678' },
    { name: 'Venezuela', code: 'VE', countryCallingCode: '+58' },
    { name: 'Viet Nam', code: 'VN', countryCallingCode: '+84' },
    {
      name: 'Virgin Islands, British',
      code: 'VG',
      countryCallingCode: '+1-284'
    },
    { name: 'Virgin Islands, U.S.', code: 'VI', countryCallingCode: '+1-340' },
    { name: 'Wallis and Futuna', code: 'WF', countryCallingCode: '+681' },
    { name: 'Western Sahara', code: 'EH', countryCallingCode: '+212' },
    { name: 'Yemen', code: 'YE', countryCallingCode: '+967' },
    { name: 'Zambia', code: 'ZM', countryCallingCode: '+260' },
    { name: 'Zimbabwe', code: 'ZW', countryCallingCode: '+263' }
  ],

  usStates: [
    { name: 'California', code: 'CA' },
    { name: 'Alaska', code: 'AK' },
    { name: 'Alabama', code: 'AL' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'District of Columbia', code: 'DC' },
    { name: 'Delaware', code: 'DE' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Guam', code: 'GU' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Maine', code: 'ME' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Montana', code: 'MT' },
    { name: 'North Carolina', code: 'NC' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New York', code: 'NY' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Virgin Islands', code: 'VI' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Washington', code: 'WA' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wyoming', code: 'WY' }
  ]
}
